import { computed } from 'vue'
import { useRoute } from 'vue-router'

import PAGE_NAME from '@web/consts/PAGE_NAME'

const HOME_ROUTES = [PAGE_NAME.HOME]

const SUPPORT_ROUTES = [
  PAGE_NAME.SUPPORT,
  PAGE_NAME.SUPPORT_CATEGORY,
  PAGE_NAME.SUPPORT_CATEGORY_STREAM
]

const SUBSCRIPTIONS_ROUTES = [
  PAGE_NAME.SUBSCRIPTIONS,
  PAGE_NAME.SUBSCRIPTION
]

const CLUB_ROUTES = [
  PAGE_NAME.CLUB_CHOOSE,
  PAGE_NAME.CLUB_CATEGORY,
  PAGE_NAME.CLUB_ARTICLE,
  PAGE_NAME.CLUB_ARTICLE_PREVIEW,
  PAGE_NAME.CLUB_TAG,
  PAGE_NAME.CLUB_SUBSCRIBE,
  PAGE_NAME.CLUB_SORRY
]

const PROFILE_ROUTES = [PAGE_NAME.EDIT_PROFILE]

const POINTS_ROUTES = [PAGE_NAME.POINTS, PAGE_NAME.POINTS_HISTORY]

const REMINDERS_ROUTES = [
  PAGE_NAME.SETTINGS_REMINDERS_TRAINING,
  PAGE_NAME.SETTINGS_NEW_REMINDER_TRAINING,
  PAGE_NAME.SETTINGS_REMINDER_TRAINING
]

const SETTINGS_ROUTES = [
  ...REMINDERS_ROUTES,
  PAGE_NAME.SETTINGS_SOCIAL_NETWORKS,
  PAGE_NAME.SETTINGS_NOTIFICATIONS,
  PAGE_NAME.SETTINGS_USER_PAYMENT_METHODS,
  PAGE_NAME.INSTALLMENTS
]

export function useMenuActiveSection () {
  const route = useRoute()
  const currentRouteName = computed(() => route.name as string)

  const isActiveHome = computed(() => HOME_ROUTES.includes(currentRouteName.value))
  const isActiveClub = computed(() => CLUB_ROUTES.includes(currentRouteName.value))
  const isActiveSupport = computed(() => SUPPORT_ROUTES.includes(currentRouteName.value))
  const isActiveSubscriptions = computed(() => SUBSCRIPTIONS_ROUTES.includes(currentRouteName.value))
  const isActiveEditProfile = computed(() => PROFILE_ROUTES.includes(currentRouteName.value))
  const isActivePoints = computed(() => POINTS_ROUTES.includes(currentRouteName.value))
  const isActiveReminders = computed(() => REMINDERS_ROUTES.includes(currentRouteName.value))

  const isProfileSection = computed(
    () => PROFILE_ROUTES.includes(currentRouteName.value) || POINTS_ROUTES.includes(currentRouteName.value)
  )
  const isSettingsSection = computed(() => SETTINGS_ROUTES.includes(currentRouteName.value))

  return {
    isActiveHome,
    isActiveClub,
    isActiveSupport,
    isActiveSubscriptions,
    isActiveEditProfile,
    isActivePoints,
    isActiveReminders,
    isProfileSection,
    isSettingsSection
  }
}
